module.exports = __webpack_public_path__ + "media/images/icon-close2-19b8c24b8c8ded31a5906840b32e1023.png";